import React from "react";
import ClientList from "./Clients/ClientList";
import Header from "./Header";

const Home: React.FC = () => {
  return (
    <div className="bg-gradient min-h-screen">
      <Header />

      <main className="max-w-5xl mx-auto px-6 py-6 bg-white rounded-lg shadow-lg text-gray-800">
        <div className="text-center mt-4">
          <h2 className="text-xl font-semibold text-gray-700">
            Welcome to Your AI-Powered CRM
          </h2>
          <p className="text-sm text-gray-500">
            Manage clients effortlessly and unlock productivity with AI
            insights.
          </p>
        </div>
        <section className="p-6 bg-gray-50 rounded-lg shadow-sm">
          <ClientList />
        </section>
        {/* <section className="mt-8 p-6 bg-blue-50 rounded-lg shadow-sm text-center">
          <h3 className="text-lg font-semibold text-gray-700">
            Boost Productivity with AI Insights
          </h3>
          <p className="text-sm text-gray-500 mt-2">
            Our AI-powered tools help you uncover actionable insights from client interactions.
          </p>
          <div className="mt-4">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md shadow hover:bg-blue-700">
              Learn More
            </button>
          </div>
        </section> */}
        <footer className="mt-8 py-4 border-t text-center text-sm text-gray-500 bg-gray-50">
          <p>
            Powered by{" "}
            <span className="font-semibold text-blue-600">proxycrm.AI</span> 🤖
          </p>
        </footer>
      </main>
    </div>
  );
};

export default Home;
